"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setRecipientSelectedState_1 = require("../actions/setRecipientSelectedState");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_mail_subject_picker_store_1 = require("owa-mail-subject-picker-store");
var owa_mail_feature_flags_1 = require("owa-mail-feature-flags");
exports.default = legacy_1.action('removeReadWriteRecipient')(function removeReadWriteRecipient(recipientWell, recipientLocatorToRemove, selectToRight) {
    var indexToRemove = -1;
    if (typeof recipientLocatorToRemove === 'number') {
        indexToRemove = recipientLocatorToRemove;
    }
    else {
        indexToRemove = recipientWell.recipients.indexOf(recipientLocatorToRemove);
    }
    if (indexToRemove >= 0) {
        var recipientToRemove = recipientWell.recipients[indexToRemove];
        if (recipientToRemove.blockRecipientRemoval) {
            return;
        }
        var removedRecipient = recipientWell.recipients.splice(indexToRemove, 1);
        if (removedRecipient[0].isSelected && recipientWell.recipients.length > 0) {
            setRecipientSelectedState_1.default(recipientWell.recipients[selectToRight
                ? Math.min(indexToRemove, recipientWell.recipients.length - 1)
                : Math.max(0, indexToRemove - 1)], true);
        }
        recipientWell.isDirty = true;
    }
    if (owa_mail_feature_flags_1.isMailFeatureEnabled('peo-subjectPicker')) {
        if (recipientWell.recipients.length === 1) {
            owa_mail_subject_picker_store_1.oneRecipientSelectedAction(recipientWell.recipients[0].persona);
        }
    }
});
//# sourceMappingURL=removeReadWriteRecipient.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/removeReadWriteRecipient.js
// module id = 2897
// module chunks = 2 3